module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-light-gray-90cc9f8d00bf0271d1193efd523bd9ee.png";